import { http } from 'cdui-js';
import { objectToQueryString } from '../lib/utils';

/** 按父级编码查询子区域（国家→省→市）。query 必须带 parentCode */
export function fetchRegionChildren(parentCode: string, regionLevel?: number) {
  const query: Record<string, string | number> = { parentCode };
  if (regionLevel != null) query.regionLevel = regionLevel;
  return http.get(`/base/region/children${objectToQueryString(query)}`);
}
